import { combineReducers } from 'redux';
import { viewTreeDucks } from '@saucelabs/sl-component-viewtree-inspector';

import containerReducer from './ducks/container';
import jobReducer from './ducks/job';
import embeddedContainerReducer from './ducks/embedded-container';
import fileReducer from './ducks/file';
import rawJobReducer from './ducks/rawJob';
import rdcPreviewSessionReducer from './ducks/rdc-preview-session';
import rootCausesReducer from './ducks/root-cause/reducers';
import errorReportReducer from './ducks/errorReport/reducers';
import componentSync from './ducks/component-sync/slice';
import videoReducer from './ducks/video/slice';

const reducers = {
  container: containerReducer,
  embeddedContainer: embeddedContainerReducer,
  job: jobReducer,
  files: fileReducer,
  rawJob: rawJobReducer,
  rdcPreviewSession: rdcPreviewSessionReducer,
  rootCause: rootCausesReducer,
  errorReport: errorReportReducer,
  viewTree: viewTreeDucks.reducers.viewTreeReducer,
  componentSync,
  video: videoReducer,
};

export default combineReducers(reducers);
